// extracted by mini-css-extract-plugin
export default {"withSidebar":"page_layout___withSidebar___c77a5bb9","withLeftSidebar":"page_layout___withLeftSidebar___d3a5d1a5"};